import { render, staticRenderFns } from "./ArticleDetailPage.vue?vue&type=template&id=aa8bd3f2&scoped=true"
import script from "./ArticleDetailPage.vue?vue&type=script&lang=js"
export * from "./ArticleDetailPage.vue?vue&type=script&lang=js"
import style0 from "./ArticleDetailPage.vue?vue&type=style&index=0&id=aa8bd3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8bd3f2",
  null
  
)

export default component.exports